import { QueryKey, useQuery, QueryResult, QueryConfig } from "react-query";
import { AxiosRequestConfig } from "axios";
import api from "../index";
import type { Credits } from "types/generated";

export const getTeamCredits = async (
  teamId: number,
  options?: AxiosRequestConfig,
): Promise<Credits> => {
  const { data } = await api.get<Credits>(
    `/payments/teams/${teamId}/credits`,
    options,
  );
  return data;
};

export const getTeamCreditsQueryKey = (teamId: number) => [
  `payments/teams/${teamId}/credits`,
];

export const useTeamCredits = (
  teamId: number,
  options?: {
    query?: QueryConfig<Credits, void>;
    request?: AxiosRequestConfig;
  },
): QueryResult<Credits, void> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options || {};
  const queryKey = queryOptions?.queryKey ?? getTeamCreditsQueryKey(teamId);

  const queryFn = () => getTeamCredits(teamId, requestOptions);

  const query = useQuery(queryKey, queryFn, {
    ...queryOptions,
  });

  return {
    queryKey,
    ...query,
  };
};
